import { GET } from '@/plugins/axios'

const baseUrl = `${process.env.VUE_APP_PINES}/settings`

export const getSettingsDepartmentsTree = (params = {}) => {
  return GET(`${baseUrl}/deptsTree`, params)
}
